/**
 * Table border colours, shared by DataTable and the few tables built on
 * Chakra's Table directly, so every table in the app is framed the same way.
 *
 * Both come from the theme's green-grey scales, so they sit between the mint
 * header and the dark text rather than competing with either: a sage frame
 * around the table, and lighter lines between its rows and columns.
 */
export const TABLE_FRAME_COLOR = 'support.800';
export const TABLE_GRID_COLOR = 'surface.400';
